export default "__VITE_ASSET__BBm85x$i__"